/**
 * @type {String}
 */
export const CLASS_NAME = 'brzw-calendar-service-summary';

/**
 * @type {String}
 */
export const SKELETON_CLASS_NAME = 'brzw-calendar-service-summary-skeleton';

/**
 * @type {Object}
 */
export const SUMMARY_LABELS = {
  CLEANINGS: 'Cleanings',
  INSPECTIONS: 'Inspections',
  MAINTENANCE: 'Maintenance',
  CHECKINS: 'Check-ins',
  CHECKOUTS: 'Checkouts',
  BACK_TO_BACKS: 'Back to Backs',
};
